import React from 'react';
import { Grid } from 'react-bootstrap';
import Table from './Table';
import Header from './Header';
import Footer from './Footer';
import MainMenu from '../menu/MainMenu';
import { GFTeacherUser } from '../../models/models';

type Props = {
  teacher: GFTeacherUser|undefined;
}

const PerformanceMetricsView: React.FC<Props> = ({ teacher }) => (
  <Grid className="content modal-container">
    <div className="sidemenu">
      <MainMenu/>
    </div>
    <div className="students main-content content-with-sidebar">
      <Header teacher={teacher}/>
      <Table teacher={teacher}/>
      <Footer teacher={teacher}/>
    </div>
  </Grid>
);

export default PerformanceMetricsView;
